import PocketBase, { LocalAuthStore } from 'pocketbase'

const configuredPocketBaseUrl = import.meta.env.VITE_POCKETBASE_URL || '/pb'

// Em desenvolvimento, usa o proxy do Vite na mesma origem do app. Assim o
// celular só precisa alcançar a porta 5173; API e arquivos do PocketBase são
// encaminhados internamente pelo Mac para a porta 8090.
export const pocketbaseUrl = configuredPocketBaseUrl.startsWith('/')
  ? `${window.location.origin}${configuredPocketBaseUrl}`
  : configuredPocketBaseUrl

// Chave de storage namespaced: o SDK do PocketBase usa uma chave fixa por
// padrão, que colide entre projetos locais diferentes rodando na mesma
// origem (ex.: várias apps Vite em localhost:5173 em dias diferentes).
// Sem isso, o app pode "herdar" a sessão de outro projeto sem avisar.
export const pb = new PocketBase(pocketbaseUrl, new LocalAuthStore('pb_auth_lorena_sistema'))
pb.autoCancellation(false)
pb.beforeSend = (url, options) => {
  const method = String(options.method || 'GET').toUpperCase()
  if (method === 'GET' && url.includes('/api/collections/link_bio_items/records')) {
    const nextUrl = new URL(url)
    nextUrl.searchParams.set('_cb', String(Date.now()))
    return { url: nextUrl.toString(), options }
  }
  return { url, options }
}

export async function isPocketBaseAvailable() {
  try {
    await pb.health.check()
    return true
  } catch {
    return false
  }
}
